import { getFullUrl, isFormData } from '@golden/getch';
import { getUnixTime } from 'date-fns';
import { NowTime } from '../utils/NowTime';
import { from, concatMap } from 'rxjs';
const SECRET_1 = 'SGFxVDNkZTZMNHJnYlM5Uk';
const SECRET_2 = 'VFSEc0TTVUSzhKRExYRW4=';
async function hmacWithWebCrypto(input) {
    const subtle = window.crypto.subtle ?? window.crypto.webkitSubtle;
    if (!subtle)
        throw new Error('No support web crypto in this browser.');
    const enc = new TextEncoder();
    const algorithm = { name: 'HMAC', hash: 'SHA-256' };
    const key = await subtle.importKey('raw', enc.encode(atob(SECRET_1 + SECRET_2)), algorithm, false, ['sign', 'verify']);
    const signature = await subtle.sign(algorithm.name, key, enc.encode(input));
    return [...new Uint8Array(signature)].map((x) => x.toString(16).padStart(2, '0')).join('');
}
async function hmacWithNodeForge(input) {
    const { createHmac, util } = await import('../utils/crypto');
    const signer = createHmac.create();
    signer.start('sha256', atob(SECRET_1 + SECRET_2));
    signer.update(util.encodeUtf8(input));
    return signer.digest().toHex();
}
async function hmac(input) {
    try {
        return await hmacWithWebCrypto(input);
    }
    catch (e) {
        console.log(e);
        return await hmacWithNodeForge(input);
    }
}
function getPathFromConfig(config) {
    const fullUrl = getFullUrl(config);
    if (fullUrl.startsWith('/'))
        return fullUrl;
    try {
        const url = new URL(fullUrl);
        return url.pathname;
    }
    catch {
        return fullUrl;
    }
}
export function addSignature() {
    return (obs) => obs.pipe(concatMap((config) => from((async () => {
        try {
            const now = getUnixTime(NowTime.get());
            config.headers['X-Date'] = now.toString();
            const pathname = getPathFromConfig(config);
            const body = (() => {
                if (isFormData(config.data) || typeof config.data === 'string') {
                    // TODO: FormData no signature
                    // eslint-disable-next-line @typescript-eslint/no-base-to-string
                    return config.data.toString();
                }
                if (typeof config.data === 'object') {
                    return JSON.stringify(config.data);
                }
                return '';
            })();
            const input = `${now.toString()}${config.method}${pathname}${body}`;
            // @ts-expect-error debug information
            config.__DEBUG__ = btoa(encodeURIComponent(input));
            config.headers['X-Signature'] = await hmac(input);
            return config;
        }
        catch (e) {
            console.error('signature error', e);
            return config;
        }
    })())));
}
//# sourceMappingURL=Signature.js.map